import styled from 'styled-components'

const MenuItemsStyle = styled.div`
	--menuRoutesMarginLeft: var(--sp13x);

	--footerMenuMaxWidth: var(--sp56x);
	--footerMenuItemMarginRight: var(--sp11x);
	--footerMenuItemMarginBottom: var(--sp6x);
	--footerMenuMarginLeft: var(--sp30x);

	display: flex;
	flex-direction: ${(props) => (props.type === 'burger' || props.type === 'footer' ? 'column' : 'auto')};
	margin-left: ${(props) => (props.type === 'footer' ? 'var(--footerMenuMarginLeft)' : props.type === 'burger' ? 0 : 'auto')};
	max-width: ${(props) => (props.type === 'footer' ? 'var(--footerMenuMaxWidth)' : '')};
	flex-wrap: ${(props) => (props.type === 'footer' ? 'wrap' : '')};
	max-height: ${(props) => (props.type === 'footer' ? 'var(--sp36x)' : '')};

	.menuRoutes {
		margin-left: ${(props) => (props.type === 'footer' ? 0 : 'var(--menuRoutesMarginLeft)')};
		margin-right: ${(props) => (props.type === 'footer' ? 'var(--footerMenuItemMarginRight)' : 0)};
		margin-bottom: ${(props) => (props.type === 'footer' ? 'var(--footerMenuItemMarginBottom)' : 0)};

		.linkInnerText {
			background-image: linear-gradient(to right, var(--cream), var(--cream) 50%, var(--orange) 50%);
			background-size: 200%;
			background-position: 0%;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			transition: var(--trTime);

			&:hover {
				background-position: -100%;
			}

			&.active {
				color: var(--orange);
				background-image: linear-gradient(to right, var(--orange), var(--orange) 50%, var(--orange) 50%);
			}
		}
	}

	.animStartPos {
		transform: translateY(100%);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--menuRoutesMarginLeft: var(--sp10x);
		--footerMenuMaxWidth: var(--sp43x);
		--footerMenuItemMarginRight: var(--sp8x);
		--footerMenuItemMarginBottom: var(--sp5x);
		--footerMenuMarginLeft: var(--sp24x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--menuRoutesMarginLeft: var(--sp9x);
		--footerMenuMaxWidth: var(--sp32x);
		--footerMenuItemMarginRight: var(--sp6x);
		--footerMenuItemMarginBottom: var(--sp4x);
		--footerMenuMarginLeft: var(--sp18x);
		max-height: ${(props) => (props.type === 'footer' ? 'var(--sp30x)' : '')};
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--menuRoutesMarginLeft: var(--sp8x);
		--footerMenuMaxWidth: var(--sp5x);
		--footerMenuItemMarginRight: 0;
		--footerMenuItemMarginBottom: var(--sp3x);
		--footerMenuMarginLeft: var(--sp20x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--menuRoutesMarginLeft: var(--sp6x);
		--footerMenuMaxWidth: var(--sp27x);
		--footerMenuItemMarginRight: var(--sp5x);
		--footerMenuItemMarginBottom: var(--sp3x);
		--footerMenuMarginLeft: 0;

		margin-top: ${(props) => (props.type === 'footer' ? 'var(--sp5x)' : '')};
		max-height: ${(props) => (props.type === 'footer' ? 'var(--sp12x)' : '')};

		.menuRoutes {
			.linkInnerText {
				&:hover {
					background-position: 0%;
				}
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--menuRoutesMarginLeft: 0;
		--footerMenuMaxWidth: var(--sp22x);
		--footerMenuItemMarginRight: var(--sp2x);
		--footerMenuItemMarginBottom: var(--sp2x);
		--footerMenuMarginLeft: 0;

		.menuRoutes {
			.linkInnerText {
				&:hover {
					background-position: 0%;
				}
			}
		}

		display: ${(props) => (props.type === 'burger' || props.type === 'footer' ? 'flex' : 'none')};
		margin-top: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
		max-height: ${(props) => (props.type === 'footer' ? 'var(--sp18x)' : '')};
	}
`

export default MenuItemsStyle
